import CollectionApi from 'client/api/v2/CollectionApi';

class SystemGroupApi extends CollectionApi {
  constructor() {
    super('/api/v2/systemgroups', {
      skip: 0,
      limit: 50,
      sort: 'name', // Prepend with a '-' to reverse default sort direction
      filter: [{
        name: 'name',
        operator: 'search',
      }],
    });
  }

  async fetchSystemGroupById(id) {
    await this.initialize();

    const { data } = await this.axios.get(`${this.baseUrl}/${id}`);
    return data;
  }

  /**
   * Retrieves membership information from a system group
   * @param {string} systemGroupId ID of the system group
   */
  getMembership(systemGroupId) {
    return this
      .initialize()
      .then(() => this.axios.get(`${this.baseUrl}/${systemGroupId}/membership`));
  }
}

export default new SystemGroupApi();
